<template>
  <div id="AppointmentCard">
    <div class="topRow">
      <div class="textColumn">
        <div v-if="item.serviceName" class="title">
          {{ item.serviceName }}
        </div>
        <div v-if="item.clinician && item.clinician.name" class="name">
          <span>{{ item.clinician.name }}</span>
        </div>
        <div v-if="appointmentTime" class="time">
          <i class="fa-solid fa-clock" aria-hidden="true"></i>
          {{ appointmentTime }}
        </div>
      </div>
      <div class="dateColumn">
        <div class="day">{{ appointmentDay }}</div>
        <div class="month">{{ appointmentMonth }}</div>
      </div>
    </div>
    <div v-if="upcoming" class="pt-4">
      <div v-if="cancelMode" class="areYouSure">
        Are you sure you want to cancel your appointment?
      </div>
      <div v-if="!cancelMode" class="btnRow">
        <div class="joinBtn cardBtn" @click="joinAppointment(item)">
          Join
        </div>
        <div
          class="cancelBtn cardBtn"
          v-if="canCancel"
          @click="cancelMode = true"
        >
          Cancel
        </div>
      </div>
      <div v-else class="cancelMode btnRow">
        <div class="cardBtn cancelBtn position-relative" @click="cancelBooking">
          <span v-if="cancellationInProgress" class="button-loading"></span>
          <span v-else>Yes, cancel</span>
        </div>
        <div class="cardBtn greenBtn" @click="cancelMode = false">Go back</div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import EventBus from "../helpers/eventbus";
import MeetingRoomModal from "./DMH/Booking/MeetingRoomModal.vue";
import axios from "axios";
import config from "../config/constants";

export default {
  props: ["item", "upcoming"],
  name: "AppointmentCard",
  data() {
    return {
      cancelMode: false,
      cancellationInProgress: false
    };
  },
  computed: {
    canCancel() {
      return true;
    },
    appointmentTime() {
      const startMoment = moment(this.item.startTime);
      const endMoment = moment(this.item.endTime);
      const formattedStartTime = startMoment.format("HH:mm");
      const formattedEndTime = endMoment.format("HH:mm");
      return `${formattedStartTime} - ${formattedEndTime}`;
    },
    appointmentDay() {
      const startMoment = moment(this.item.startTime);
      return startMoment.format("DD");
    },
    appointmentMonth() {
      const startMoment = moment(this.item.startTime);
      return startMoment.format("MMM");
    }
  },
  methods: {
    joinAppointment(booking) {
      this.openBookingModal(booking);
    },
    openBookingModal(booking) {
      const content = this.$createElement(MeetingRoomModal, {
        props: { booking: booking }
      });
      const skin = this.$store.getters.skin;
      let opts = {
        title: "My Coaching Session",
        hideHeader: true,
        hideFooter: true,
        modalClass: "coach_modal theme-" + skin,
        headerClass:
          "coach_modal_header bg-brand-secondary d-flex justify-content-center",
        size: "lg",
        buttonSize: "sm",
        centered: true,
        contentClass: "coach_modal",
        id: "digital_clinics_modal"
      };
      return this.$bvModal.msgBoxOk(content, opts);
    },
    async cancelBooking() {
      if (this.cancellationInProgress) {
        return;
      }
      this.cancellationInProgress = true;
      const payload = {
        user_id: this.$store.getters.user_id,
        appointment_id: this.item?.appointmentId,
        appointment_type: this.item?.appointmentType?.toLowerCase(),
        message: "User cancelled the session"
      };
      const res = await axios.post(
        config.api_env +
          "/application/api/u/dmh/cancel-appointment",
        payload,
        config.options
      );
      this.cancellationInProgress = false;
      if (res.data.success) {
        EventBus.$emit("getAppointments");
      }
    },
  }
};
</script>
<style lang="less">
#AppointmentCard {
  width: 100%;
  color: #333333;
  background-color: #ffffff;
  border: 0;
  border-radius: 6px;
  box-shadow: 0px 2px 2px 0px #33333326;
  padding: 16px;
  .topRow {
    display: grid;
    grid-template-columns: 4fr 1fr;
    .textColumn {
      color: #333333;
      .title {
        font-family: "DMSans Bold";
        font-size: 1.8rem;
      }
      .name {
        font-family: "DMSans";
        font-size: 1.6rem;
        margin-bottom: 8px;
      }
      .time {
        font-family: "DMSans";
        font-size: 1.6rem;
        color: #333333;
        i {
          color: #333333;
          font-size: 1.6rem;
          margin-right: 4px;
        }
      }
    }
    .dateColumn {
      padding-right: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #403d56;
      .day {
        font-family: "DMSans Bold";
        font-size: 5.6rem;
        line-height: 5rem;
      }
      .month {
        font-family: "DMSans Bold";
        font-size: 1.8rem;
      }
    }
  }
  .areYouSure {
    font-size: 1.8rem;
    line-height: 2rem;
    font-family: "DMSans Bold";
    margin-bottom: 12px;
  }
  .btnRow {
    display: flex;
    width: 100%;
    justify-content: space-between;
    gap: 8px;
    .cardBtn {
      width: 100%;
      padding: 12px 16px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 15px;
      font-family: "DMSans Bold";
      color: #fff;
      font-size: 1.6rem;
      cursor: pointer;
      border: 0;
      margin-right: 5px;
    }
    .joinBtn {
      color: white;
      background: #604bff;
      i {
        margin-right: 10px;
      }
    }
    .cancelBtn {
      background-color: #ef2a1d;
    }
    .greenBtn {
      background: #30de7a;
    }
  }
  .button-loading::after {
    content: "";
    position: absolute;
    width: 20px;
    height: 20px;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    border: 4px solid transparent;
    border-radius: 50%;
    border-top-color: white;
    border-bottom-color: white;
    animation: button-loading-spinner 1s ease infinite;
  }
}
</style>
